export const Environment = {
	API_BASE_URL: process.env.API_BASE_URL! + process.env.API_WEB_URL_PREFIX,
	API_BASE_URL_ADMIN: process.env.API_BASE_URL! + process.env.API_ADMIN_URL_PREFIX,
	APP_BASE_URL: process.env.APP_BASE_URL,
	FIREBASE_WEB_CLIENT_ID: process.env.FIREBASE_WEB_CLIENT_ID,
	FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
	FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
	FIREBASE_DATABASE_URL: process.env.FIREBASE_DATABASE_URL,
	FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
	FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET,
	FIREBASE_MESSENGING_SENDER_ID: process.env.FIREBASE_MESSENGING_SENDER_ID,
	FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
	FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
	MIXPANEL_TOKEN: process.env.MIXPANEL_TOKEN,
	SENTRY_DSN: process.env.SENTRY_DSN,
	SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE,
	LABEL_VERSION: process.env.LABEL_VERSION,
	GETSTREAM_API_KEY: process.env.GETSTREAM_API_KEY,
	APP_VARIANT: process.env.APP_VARIANT as "jaangal" | "tooshare",
	APP_ENV: process.env.APP_ENV as "dev" | "demo" | "prod" | undefined,
};

export const isDevEnvironment = Environment.APP_ENV === "dev";
